import { get, post, put, patch, del } from "src/services/api";

const fetchOpenDrafts = async () => {
  const endpoint = "/admin/drafts";
  return await get({ endpoint });
};

const duplicateAssistant = async (data) => {
  const endpoint = "/v2/admin/assistants/duplicate";
  return await post({ endpoint, data });
};

const extendDraft = async (data) => {
  const endpoint = `/admin/drafts/extend-draft-expiration/${data.assistantId}`;
  return await patch({ endpoint, data });
};

const changeDraftOwner = async ({ assistantId, createdBy }) => {
  const endpoint = `/admin/drafts/change-draft-owner/${assistantId}`;
  return await patch({ endpoint, data: { createdBy } });
};

const fetchDraftOwners = async (accountId) => {
  const endpoint = `/admin/drafts/draft-owners/${accountId}`;
  return await get({ endpoint });
};

const fetchFailures = async () => {
  const endpoint = "/admin/drafts/failures";
  return await get({ endpoint });
};

const fetchDataMappingsTables = async () => {
  const endpoint = "admin/assistants/collections/tables";
  return await get({ endpoint });
};

const fetchSpecRefs = async (params) => {
  const endpoint = `admin/assistants/collections/spec-refs/${params.collectionName}`;
  return await get({ endpoint, params: { channel: params.channel } });
};

const fetchTablesOptions = async (params) => {
  const endpoint = `admin/assistants/collections/${params.collectionName}/${params.collectionInstanceId}/table-options`;
  return await get({ endpoint });
};

const fetchTableByTableId = async (params) => {
  const endpoint = `admin/assistants/collections/${params.collectionName}/${params.collectionInstanceId}/table/${params.tableId}/fields`;
  return await get({ endpoint });
};

const updateTableFields = async (params) => {
  const endpoint = `admin/assistants/collections/${params.collectionName}/${params.collectionInstanceId}/table/${params.tableId}/fields`;
  return await patch({ endpoint, data: params.data });
};

const createTable = async (params) => {
  const endpoint = `admin/assistants/collections/${params.collectionName}/${params.collectionInstanceId}/table/${params.tableId}`;
  return await post({ endpoint, data: params.data });
};

const updateGrouping = async (params) => {
  const endpoint = `admin/assistants/collections/${params.collectionName}/${params.collectionInstanceId}/table/${params.tableId}/grouping`;
  return await patch({ endpoint, data: params.data });
};

const fetchSftpSettings = async (accountId) => {
  const endpoint = `/admin/accounts/${accountId}/sftp/settings`;
  return await get({ endpoint });
};

const fetchConfigurableContent = async ({ collectionName, collectionSpecKey }) => {
  const endpoint = `admin/assistants/collections/content/${collectionName}/${collectionSpecKey}`;
  return await get({ endpoint });
};

const upsertConfigurableContent = async ({ key, data }) => {
  const endpoint = `admin/assistants/collections/content/entry/${key}`;
  return await put({ endpoint, data });
};

const bulkUpsertConfigurableContent = async ({ collectionName, collectionSpecKey, data }) => {
  const endpoint = `admin/assistants/collections/content/bulk/${collectionName}/${collectionSpecKey}`;
  return await put({ endpoint, data });
};

const deleteConfigurableContent = async ({ key }) => {
  const endpoint = `admin/assistants/collections/content/entry/${key}`;
  return await del({ endpoint });
};

const getConfigurableContentDefaults = async ({ key }) => {
  const endpoint = `admin/assistants/collections/content/entries/${key}/defaults`;
  return await get({ endpoint });
};

const initializeConfigurableContent = async ({ collectionName, collectionSpecKey }) => {
  const endpoint = `admin/assistants/collections/content/initialize/${collectionName}/${collectionSpecKey}`;
  return await post({ endpoint });
};

const fetchSubscription = async (accountId) => {
  const endpoint = `/admin/accounts/${accountId}/salesforce/subscription`;
  return await get({ endpoint });
};

const fetchFeatureAdoption = async () => {
  const endpoint = "/feature-adoption/features";
  return await get({ endpoint });
};

const fetchFeatureAgents = async ({ featureId, ...params }) => {
  const endpoint = `/feature-adoption/features/${featureId}/agents`;
  return await get({ endpoint, params });
};

const fetchAgentFeatures = async ({ assistantId, ...params }) => {
  const endpoint = `/feature-adoption/agents/${assistantId}/features`;
  return await get({ endpoint, params });
};

export default {
  fetchOpenDrafts,
  duplicateAssistant,
  extendDraft,
  changeDraftOwner,
  fetchDraftOwners,
  fetchFailures,
  fetchDataMappingsTables,
  fetchSpecRefs,
  fetchTablesOptions,
  fetchTableByTableId,
  updateTableFields,
  createTable,
  updateGrouping,
  fetchSftpSettings,
  fetchConfigurableContent,
  upsertConfigurableContent,
  bulkUpsertConfigurableContent,
  deleteConfigurableContent,
  getConfigurableContentDefaults,
  initializeConfigurableContent,
  fetchSubscription,
  fetchFeatureAdoption,
  fetchFeatureAgents,
  fetchAgentFeatures
};
